import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Vec steampunka",
  "description": "",
  "published": "2007-03-02T00:00:00.000Z",
  "redirect_from": ["/blog/vec-steampunka/swizec/272"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Danes me je ljubeznivi `}<a parentName="p" {...{
        "href": "http://forum.darkness.com/index.php"
      }}>{`darkness forum`}</a>{` osrecil z nacinom pridobitve nekaj zelo zanimivih steampunk linkov. Nasel sem `}<a parentName="p" {...{
        "href": "http://forum.darkness.com/index.php"
      }}><em parentName="a">{`Steampunk`}</em></a>{` - novo steampunk revijo, `}<a parentName="p" {...{
        "href": "http://www.brassgoggles.co.uk/brassgoggles/"
      }}><em parentName="a">{`Brass Goggles`}</em></a>{` - zanimiv in pogosto posodabljan blog na to temo in `}<em parentName="p"><a parentName="em" {...{
          "href": "http://www.lycettebros.com/automata/index.html"
        }}>{`The Modern Compendum of Miniature Automata`}</a></em>{` -ki ga pravzaprav ne morem dobro uvrstiti ampak je zabaven.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      